import React, { Component, useContext } from 'react';
import { func, object, shape, string, bool } from 'prop-types';
import { a, m } from 'kremling';
import { get } from 'lodash';
import { Button } from 'components/button/button.component';
import { UserStateContext } from 'context/user-state-context';
import { getForms } from 'shared/forms.api';
import { DynamicTypeAhead } from '../../../../components/dynamic-type-ahead/dynamic-type-ahead.component';
import { getConvrrtPages } from 'shared/common.api';
export const TriggerWebForm = ({
  update,
  data
}) => {
  const {
    asCompany,
    hasIntegration
  } = useContext(UserStateContext);
  const {
    use_form,
    formId,
    uuid,
    use_landing_page,
    lp_form_id,
    form_name
  } = data;
  return <div className="pt-md">
      <div className="toggler toggler--block mb-md">
        <Button className={m('active', use_form)} onClick={() => update({
        use_form: true,
        use_landing_page: false
      })}>
          Choose Form
        </Button>
        {hasIntegration('convrrt') && <Button className={m('active', use_landing_page)} onClick={() => update({
        use_form: false,
        use_landing_page: true
      })}>
            Landing Page
          </Button>}
        <Button className={m('active', !use_form && !use_landing_page)} onClick={() => update({
        use_form: false,
        use_landing_page: false
      })}>
          Custom
        </Button>
      </div>

      {!use_form && !use_landing_page && <>
          <div className="form-group">
            <label>Instructions</label>
            <p>
              Set up a form to <code>POST</code> to the following url:
            </p>
            <a href={`${API_URL}/form/${uuid}`} target="_blank">
              {API_URL}/form/{uuid}
            </a>
          </div>
          <div className="form-group">
            <label>Allowed Body Properties</label>
            <ul>
              <li>
                <code>first_name</code>
              </li>
              <li>
                <code>last_name</code>
              </li>
              <li>
                <code>email</code> (required)
              </li>
              <li>
                <code>address1</code>
              </li>
              <li>
                <code>address2</code>
              </li>
              <li>
                <code>city</code>
              </li>
              <li>
                <code>state</code>
              </li>
              <li>
                <code>zip_code</code>
              </li>
              <li>
                <code>country</code>
              </li>
              <li>
                <code>entity_data</code>
              </li>
            </ul>
          </div>
        </>}
      {use_form && <div>
          <div className="mb-md">
            <DynamicTypeAhead getItems={getForms} getItemsFilters={{
          company: asCompany.id
        }} placeholder="Select a form" displayProperty="name" keyProperty="id" value={formId} onChange={form => {
          update({
            formId: form?.id,
            form_name: form?.name
          });
        }} />
          </div>
        </div>}

      {use_landing_page && hasIntegration('convrrt') && <div>
          <div className="mb-md">
            <DynamicTypeAhead getItems={getConvrrtPages} getItemsFilters={{
          company: asCompany.id
        }} placeholder={form_name || 'Select a landing page'} displayProperty="name" keyProperty="id" value={lp_form_id} onChange={form => update({
          lp_form_id: form?.id,
          form_name: form?.name
        })} />
          </div>
        </div>}
    </div>;
};